import removeAcento from './accentFold';

const CODES = [
  [/BL|BR/, 'B'],
  ['PH', 'F'],
  [/GL|GR|MG|NG|RG/, 'G'],
  ['Y', 'I'],
  [/GE|GI|RJ|MJ/, 'J'],
  [/CA|CO|CU|CK|Q/, 'K'],
  ['N', 'M'],
  [/AO|AUM|GM|MD|OM|ON/, 'M'],
  ['PR', 'P'],
  ['L', 'R'],
  [/CE|CI|CH|CS|RS|TS|X|Z/, 'S'],
  [/TR|TL/, 'T'],
  [/CT|RT|ST|PT/, 'T'],
  [/\b[UW]/, 'V'],
  ['RM', 'SM'],
  [/[MRS]+\b/, ''],
  [/[AEIOUH]/, '']
];

export default str => CODES.reduce((s, [from, to]) => s.split(from).join(to), removeAcento(str).replace(/[^a-z0-9\s]/gi, "").toUpperCase()).replace(/(.)(?=\1)/g, '');


// WEBPACK FOOTER //
// ./src/utils/buscaFonetica.js